import React from "react";

const EnvelopeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M4.36996 5.4453C4.06361 5.24107 3.6497 5.32385 3.44546 5.6302C3.24123 5.93656 3.32401 6.35047 3.63036 6.5547L6.89076 8.7283C7.56256 9.17617 8.43776 9.17617 9.10956 8.7283L12.37 6.5547C12.6763 6.35047 12.7591 5.93656 12.5549 5.6302C12.3506 5.32385 11.9367 5.24107 11.6304 5.4453L8.36996 7.6189C8.14603 7.76819 7.8543 7.76819 7.63036 7.6189L4.36996 5.4453Z"
        fill="#5243FA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.0832 1.75181C8.39369 1.44536 7.60663 1.44536 6.91713 1.75181L2.91713 3.52959C1.95412 3.95759 1.3335 4.91258 1.3335 5.96642V10.6667C1.3335 12.1394 2.5274 13.3333 4.00016 13.3333H12.0002C13.4729 13.3333 14.6668 12.1394 14.6668 10.6667V5.96642C14.6668 4.91258 14.0462 3.95759 13.0832 3.52959L9.0832 1.75181ZM7.45864 2.97022C7.8034 2.817 8.19693 2.817 8.54168 2.97022L12.5417 4.748C13.0232 4.962 13.3335 5.4395 13.3335 5.96642V10.6667C13.3335 11.403 12.7365 12 12.0002 12H4.00016C3.26378 12 2.66683 11.403 2.66683 10.6667V5.96642C2.66683 5.4395 2.97714 4.962 3.45864 4.748L7.45864 2.97022Z"
        fill="#5243FA"
      />
    </svg>
  );
};

export default EnvelopeIcon;
